import _ from "lodash";
export const obterPastosPorRetiroSelecionado = (retiroSelecionado, pastos) => {
  return retiroSelecionado === -1
    ? pastos
    : pastos.filter(function (pasto) {
        return pasto.IdRetiro === retiroSelecionado;
      });
};

export const obterPastosComLote = (farolPasto) => {
  return farolPasto.filter(function (farol) {
    return farol.Valor.Lotes.length > 0;
  });
};

export const obterPastosDoRetiroComLotes = (pastosRetiro, pastosComLotes) => {
  const pastosDoRetiroComLotes = [];

  _.forEach(pastosRetiro, (pastoRetiro) => {
    _.some(pastosComLotes, (pastoLote) => {
      if (pastoLote.IdPasto === pastoRetiro.IdPasto) {
        pastosDoRetiroComLotes.push(pastoLote);
        return true;
      }
    });
  });

  return pastosDoRetiroComLotes;
};

export const obterSomaDeCabecasDeGadoPorCategoria = (categoria, pastos) => {
  let quantidadeDeCabecas = 0;

  _.forEach(pastos, (pasto) => {
    _.forEach(pasto.Valor.Lotes, (lote) => {
      if (lote.IdCategoriaAnimal === categoria.IdCategoriaAnimal) {
        quantidadeDeCabecas += lote.Quantidade;
      }
    });
  });
  return quantidadeDeCabecas;
};

export const obterSomaDeTodasAsCategorias = (categorias, pastos) => {
  let rebanhoTodasCategorias = 0;
  _.forEach(categorias, (categoria) => {
    rebanhoTodasCategorias =
      rebanhoTodasCategorias +
      obterSomaDeCabecasDeGadoPorCategoria(categoria, pastos);
  });
  return rebanhoTodasCategorias;
};

export const obterPesoMedioTodasCategorias = (pastos, currais) => {
  let pesoMedioTodasCategorias = 0;
  let quantidadeDeCabecas = 0;
  let pesoMedioTodasCategoriasArroba = 0;
  let quantidadeDeCabecasArroba = 0;
  currais.forEach((curral) => {
    curral.Valor.Lotes.forEach((lote) => {
      if (
        lote.PesoVisual !== null &&
        lote.PesoVisual !== undefined &&
        lote.PesoVisual !== 0
      ) {
        pesoMedioTodasCategorias += lote.PesoVisual * lote.Quantidade;
        quantidadeDeCabecas += lote.Quantidade;

        if (
          lote.PesoVisualArroba !== null &&
          lote.PesoVisualArroba !== undefined
        ) {
          pesoMedioTodasCategoriasArroba +=
            lote.PesoVisualArroba * lote.Quantidade;
          quantidadeDeCabecasArroba += lote.Quantidade;
        }
      } else {
        console.log("CURRAL lote sem peso visual", lote);
      }
    });
  });

  pastos.forEach((pasto) => {
    pasto.Valor.Lotes.forEach((lote) => {
      if (
        lote.PesoVisual !== null &&
        lote.PesoVisual !== undefined &&
        lote.PesoVisual !== 0
      ) {
        pesoMedioTodasCategorias += lote.PesoVisual * lote.Quantidade;
        quantidadeDeCabecas += lote.Quantidade;

        if (
          lote.PesoVisualArroba !== null &&
          lote.PesoVisualArroba !== undefined
        ) {
          pesoMedioTodasCategoriasArroba +=
            lote.PesoVisualArroba * lote.Quantidade;
          quantidadeDeCabecasArroba += lote.Quantidade;
        }
      } else {
        console.log("PASTO lote sem peso visual", lote);
      }
    });
  });

  if (quantidadeDeCabecas === 0) {
    return { kg: 0, arroba: null };
  }

  const pesoMedioKg = pesoMedioTodasCategorias / quantidadeDeCabecas;
  const pesoMedioArroba =
    quantidadeDeCabecasArroba > 0
      ? pesoMedioTodasCategoriasArroba / quantidadeDeCabecasArroba
      : null;

  return { kg: pesoMedioKg, arroba: pesoMedioArroba };
};

export const obterSomaDeAnimaisNoCurral = (currais) => {
  let quantidadeDeCabecas = 0;
  _.forEach(currais, (curral) => {
    _.forEach(curral.Valor.Lotes, (lote) => {
      quantidadeDeCabecas += lote.Quantidade;
    });
  });
  return quantidadeDeCabecas;
};

export const obterQuantidadePastosCurralEPesoMedio = (
  pastos,
  curraisRetiroComLotes,
  categoria,
) => {
  let quantidadeDeCabecasNoCurral = 0;
  let quantidadeDeCabecas = 0;
  let quantidadeDeCabecasNoCurralComPesoVisual = 0;
  let quantidadeDeCabecasComPesoVisual = 0;
  let pesoMedio = 0;
  let pesoMedioArroba = 0;
  let quantidadeDeCabecasComPesoVisualArroba = 0;
  let quantidadeDeCabecasNoCurralComPesoVisualArroba = 0;

  pastos.forEach((pasto) => {
    pasto.Valor.Lotes.forEach((lote) => {
      if (lote.IdCategoriaAnimal === categoria.IdCategoriaAnimal) {
        quantidadeDeCabecas += Number(lote.Quantidade || 0);
      }
      if (
        lote.IdCategoriaAnimal === categoria.IdCategoriaAnimal &&
        lote.PesoVisual !== null &&
        lote.PesoVisual !== undefined &&
        lote.PesoVisual !== 0
      ) {
        quantidadeDeCabecasComPesoVisual += Number(lote.Quantidade || 0);
        pesoMedio += Number(lote.PesoVisual) * Number(lote.Quantidade || 0);

        if (
          lote.PesoVisualArroba !== null &&
          lote.PesoVisualArroba !== undefined
        ) {
          quantidadeDeCabecasComPesoVisualArroba += Number(
            lote.Quantidade || 0,
          );
          pesoMedioArroba +=
            Number(lote.PesoVisualArroba) * Number(lote.Quantidade || 0);
        }
      }
    });
  });

  curraisRetiroComLotes.forEach((curral) => {
    curral.Valor.Lotes.forEach((lote) => {
      if (lote.IdCategoriaAnimal === categoria.IdCategoriaAnimal) {
        quantidadeDeCabecasNoCurral += Number(lote.Quantidade || 0);
      }
      if (
        lote.IdCategoriaAnimal === categoria.IdCategoriaAnimal &&
        lote.PesoVisual !== null &&
        lote.PesoVisual !== undefined &&
        lote.PesoVisual !== 0
      ) {
        quantidadeDeCabecasNoCurralComPesoVisual += Number(
          lote.Quantidade || 0,
        );
        pesoMedio += Number(lote.PesoVisual) * Number(lote.Quantidade || 0);

        if (
          lote.PesoVisualArroba !== null &&
          lote.PesoVisualArroba !== undefined
        ) {
          quantidadeDeCabecasNoCurralComPesoVisualArroba += Number(
            lote.Quantidade || 0,
          );
          pesoMedioArroba +=
            Number(lote.PesoVisualArroba) * Number(lote.Quantidade || 0);
        }
      }
    });
  });

  let quantidadeDeCabecasTotal =
    quantidadeDeCabecasComPesoVisual + quantidadeDeCabecasNoCurralComPesoVisual;

  if (quantidadeDeCabecasTotal > 0) {
    pesoMedio = pesoMedio / quantidadeDeCabecasTotal;
  }

  const quantidadeDeCabecasComArroba =
    quantidadeDeCabecasComPesoVisualArroba +
    quantidadeDeCabecasNoCurralComPesoVisualArroba;

  const pesoMedioEmArroba =
    quantidadeDeCabecasComArroba > 0
      ? pesoMedioArroba / quantidadeDeCabecasComArroba
      : null;

  return {
    quantidadeDeCabecas,
    quantidadeDeCabecasNoCurral,
    pesoMedio: { kg: pesoMedio, arroba: pesoMedioEmArroba },
  };
};
